<spe-empty-list
*ngIf="!validaImportacao"
  [iconPath]="'/assets/icones/cinza/cadeado.svg'"
  [title]="'Função bloqueada'"
  [subtitle]="'Não permitido durante processamento de pedido!\n Clique no botão abaixo para acompanhar seu pedido'"
  [linkText]="''"
  [linkUrl]="''"
  [buttonText]="'Acompanhar pedido'"
  (buttonClick)="returnButton()"
  [removeButtonIcon]="true"
></spe-empty-list>

<spe-empty-list

*ngIf="validaImportacao"
  [iconPath]="'/assets/icones/cinza/cadeado.svg'"
  [title]="'Função bloqueada'"
  [subtitle]="'Não permitido durante processamento de Importação!\n Clique no botão abaixo para acompanhar a importação'"
  [linkText]="''"
  [linkUrl]="''"
  [buttonText]="'Acompanhar Importação'"
  (buttonClick)="returnImportacaoButton()"
  [removeButtonIcon]="true"
></spe-empty-list>